import React from 'react';
import Text from './text';

const Paragraph = props => <Text lineHeight="normal" {...props} />;

export default Paragraph;
